"use client"
import { useEffect, useState } from 'react'
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../../src/lib/config'

export default function ComingSoonModalClient() {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    const onOpen = () => setOpen(true)
    window.addEventListener('open-coming-soon', onOpen)
    return () => window.removeEventListener('open-coming-soon', onOpen)
  }, [])
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    window.addEventListener('keydown', onKey)
    return () => { document.body.style.overflow = prev; window.removeEventListener('keydown', onKey) }
  }, [open])
  if (!open) return null
  const wa = `https://wa.me/${String(SUPPORT_PHONE || '').replace(/\D/g, '')}`
  return (
    <div className="fixed inset-0 z-[70]">
      <button
        aria-label="Close"
        className="absolute inset-0 bg-black/40 touch-none"
        onPointerDown={(e) => { try { e.preventDefault(); e.stopPropagation() } catch {}; try { (window as any).__overlayJustClosed = Date.now() } catch {}; setOpen(false) }}
        onClick={(e) => { try { e.preventDefault(); e.stopPropagation() } catch {} }}
      />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[92vw] max-w-md rounded border bg-white p-5 shadow-2xl">
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-lg font-semibold">Coming soon</h3>
          <button onClick={()=>setOpen(false)} aria-label="Close" className="rounded px-2 py-1 hover:bg-gray-100">✕</button>
        </div>
        <p className="mt-2 text-sm text-gray-700">
          We will be live on Amazon first and then on our website. Meanwhile, for any queries or to place a direct order,
          please reach out to us.
        </p>
        <div className="mt-4 grid gap-2 text-sm">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="underline">Email: {SUPPORT_EMAIL}</a>
          <a href={`tel:${String(SUPPORT_PHONE).replace(/\s/g,'')}`} className="underline">Phone: {SUPPORT_PHONE}</a>
          <a href={wa} target="_blank" rel="noopener noreferrer" className="underline">WhatsApp</a>
        </div>
        <div className="mt-4 text-right">
          <button onClick={()=>setOpen(false)} className="inline-flex items-center rounded border px-3 py-1.5 text-sm hover:bg-gray-50">OK</button>
        </div>
      </div>
    </div>
  )
}
